import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CommonForm from "./CommonForm";
import ListComponent from "./ListComponent";

export default function Currencies(props) {
  return (
    <>
      <div className="flex-row-fluid" {...props}>
        <Switch>
          <Redirect
            from="/currencies"  
            exact={true}
            to="/currencies/list"
          />
          <Route
            path="/currencies/list"
            component={ListComponent}
          />
          <Route
            path="/currencies/create"
            component={CommonForm}
          />
          <Route
            path="/currencies/edit/:id"
            component={CommonForm}
          />
        </Switch>
      </div>
    </>
  );
}
